"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUBODeclarationReasonToString = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformUBODeclarationReasonToString(reason) {
    switch (reason) {
        case legacy_enums_1.IUBODeclarationReason.WRONG_UBO_INFORMATION:
            return "Wrong UBO information";
        case legacy_enums_1.IUBODeclarationReason.MISSING_UBO:
            return "Missing UBO";
        case legacy_enums_1.IUBODeclarationReason.UBO_IDENTITY_NEEDED:
            return "UBO identity needed";
        case legacy_enums_1.IUBODeclarationReason.DOCUMENTS_NEEDED:
            return "Documents needed";
        case legacy_enums_1.IUBODeclarationReason.SHAREHOLDERS_DECLARATION_NEEDED:
            return "Shareholders declaration needed";
        case legacy_enums_1.IUBODeclarationReason.ORGANIZATION_CHART_NEEDED:
            return "Organization chart needed";
        case legacy_enums_1.IUBODeclarationReason.DECLARATION_DO_NOT_MATCH_UBO_INFORMATION:
            return "Declaration do not match UBO information";
        case legacy_enums_1.IUBODeclarationReason.SPECIFIC_CASE:
            return "Specific case";
        default:
            return "Unknown";
    }
}
exports.transformUBODeclarationReasonToString = transformUBODeclarationReasonToString;
//# sourceMappingURL=transformUBODeclarationReasonToString.js.map